import { PAYMENT_FREQUENCIES } from "./paymentSupport";
import { Autocomplete, Grid, Stack, TextField } from "@mui/material";
import Component from "components/Component";
import Disabled from "components/common/Disabled";
import PaymentScheduleButton from "components/payments/PaymentScheduleModal";
import * as config from "config";
import { useDispatch, useSelector } from "react-redux";
import * as programPricingStore from "store/programPricing";

const ProgramPaymentTerms = () => {
  const dispatch = useDispatch();
  const programPricing = useSelector(programPricingStore.selectInput);
  const value =
    PAYMENT_FREQUENCIES.find(
      (f) => f.key === programPricing?.paymentFrequency
    ) ?? null;

  return (
    <Component title={"Payment Terms"}>
      <Grid container spacing={config.GRID_SPACING} alignItems={"center"}>
        <Grid item xs={12} sm={6}>
          <Disabled ifReadOnly>
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <Autocomplete
                sx={{ flex: 1 }}
                value={value}
                options={PAYMENT_FREQUENCIES}
                getOptionLabel={(o) => o.name}
                onChange={(_, option) =>
                  dispatch(
                    programPricingStore.update({
                      paymentFrequency: option?.key ?? null,
                    })
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={"Payment Frequency"}
                    variant={"filled"}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
                autoHighlight
              />
              <PaymentScheduleButton />
            </Stack>
          </Disabled>
        </Grid>
      </Grid>
    </Component>
  );
};

export default ProgramPaymentTerms;
